import { fetchAllBanks } from '@api/useQueryCalls';
import ListWithFilter from '@atoms/ListWithFilter';
import { View } from '@components/primitives';
import { useToast } from '@hooks';
import { useNavigation, useRoute } from '@react-navigation/native';
import appStyles from '@root/appStyles';
import { getStore } from '@store/storeUtils';
import { showErrorOnAPI } from '@utils/utils';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function GGAllBanks(): React.JSX.Element {
  const [allBanks, setAllBanks] = useState<any>([]);
  const { setInitialData, setLoading } = getStore();
  const route = useRoute<any>();
  const { setSelectedBank, source } = route.params;
  const { isError, error, isLoading, isSuccess, data } = fetchAllBanks();
  const navigation = useNavigation();
  const { t } = useTranslation('common');
  const toast = useToast();

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading]);

  useEffect(() => {
    showErrorOnAPI(isError, error, toast, t, navigation, setInitialData);
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess && data && data.list) {
      setAllBanks(data.list);
    }
  }, [isSuccess, data]);

  return (
    <View style={appStyles.safeAreaView}>
      <ListWithFilter allBanks={allBanks} setAllBanks={setAllBanks} setSelectedBank={setSelectedBank} source={source} />
    </View>
  );
}

export default GGAllBanks;
